__turbopack_context__.v({
  "icon": "no-image-module-scss-module__wou5ia__icon",
  "wrapper": "no-image-module-scss-module__wou5ia__wrapper",
});
